import { createContext, useContext, useState } from "react";
export const AuthContext = createContext(null);
export const useLocalAuth = () => useContext(AuthContext);
export default function LocalAuthProvider({children}) {
  const [token,setToken] = useState(() => sessionStorage.getItem("odonto_token"));
  const signIn = (value) => {sessionStorage.setItem("odonto_token",value);setToken(value);};
  const signOut = () => {sessionStorage.removeItem("odonto_token");setToken(null);};
  return <AuthContext.Provider value={{token,signIn,signOut}}>{children}</AuthContext.Provider>;
}
